//多站总览
const multiStationZh = {
  mulStaLang: {
    多站总览: '多站总览',
    创建电站: '创建电站',
    站点总数: '站点总数',
    个: '个',
    在线: '在线',
    离线: '离线',
    待运维: '待运维',
    装机功率: '装机功率',
    装机容量: '装机容量',
    今日充电量: '今日充电量',
    较昨日下降: '较昨日下降',
    较昨日增长: '较昨日增长',
    月充电: '月充电',
    累计充电: '累计充电',
    今日放电量: '今日放电量',
    月放电: '月放电',
    累计放电: '累计放电',
    今日收益: '今日收益',
    元: '元',
    万元: '万元',
    本月收益: '本月收益',
    总收益: '总收益',
    收益统计: '收益统计',
    充放电统计: '充放电统计',
    近7日: '近7日',
    近31日: '近31日',
    近12月: '近12月',
    开始日期: '开始日期',
    结束日期: '结束日期',
    收益排名: '收益排名',
    '收益/万元': '收益/万元',
    本月: '本月',
    本年: '本年',
    收益: '收益',

    站点列表: '站点列表',
    通讯状态: '通讯状态',
    全部: '全部',
    电站筛选: '电站筛选',
    待运维电站: '待运维电站',
    请输入电站名称: '请输入电站名称',
    查询: '查询',
    重置: '重置',
    导出: '导出',
    电站名称: '电站名称',
    待运维处理: '待运维处理',
    在线状态: '在线状态',
    总充电量: '总充电量',
    总放电量: '总放电量',
    '昨日收益(元)': '昨日收益(元)',
    '总收益(万元)': '总收益(万元)',
    综合效率: '综合效率',
    放电达成率: '放电达成率',
    序号: '序号',
    暂无数据: '暂无数据',
    复制成功: '复制成功'
  }
}

export default multiStationZh
